import type { SearchSiteTab } from "~ui/@modules/home/stores/search-site-store.ts";

const fieldPlaceholders: Record<string, string> = {
  siteId: "ID Site",
  siteExternalId: "ID Externe",
  siteAddress: "Adresse",
  sitePostalCode: "Code Postal",
  siteCity: "Ville",
  siteCountry: "Pays",
  siteDeliveryPoint: "Point de livraison",
  subscriberId: "Id Adhérent",
  firstname: "Prénom",
  lastname: "Nom",
  email: "Email",
  phone: "Numéro de téléphone",
  companyName: "Entreprise",
  pilotHwId: "Pilote - Hw Id",
  pilotCsId: "Pilote - Cs Id",
  modulatorHwId: "Modulateur - Hw Id",
  modulatorCsId: "Modulateur - Cs Id",
  modulatorSerialNumber: "Modulateur - Numéro de série",
  modulatorNeuronId: "Modulateur - Neuron Id",
  pilotSerial: "Pilote - Numéro de série",
};

const tabs: Record<SearchSiteTab, string> = {
  common: "Global",
  modulator: "Modulateur",
  pilot: "Pilote",
  site: "Site",
  subscriber: "Adhérent",
};

export const SEARCH_SITE_WRAPPER_FRENCH_LOCALE = {
  filters: "Filtres",
  clearFilters: "Vider les filtres",
  tabs: tabs,
  commonTabLegends: {
    site: "Site",
    subscriber: "Adhérent",
    pilot: "Pilote",
    modulator: "Modulateur",
  },
  fields: {
    placeholders: fieldPlaceholders,
  },
};
